import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Col, ListGroup } from 'react-bootstrap';

import PerfectScrollBar from 'react-perfect-scrollbar';

import { MdPhone, MdVerifiedUser } from 'react-icons/md';
import {
  makeGetToken,
  makeGetDefaultAccount,
  makeGetAuth,
  makeGetListAccount,
} from '../../lib/selector';
import { authListRequest } from '../modal/auth/actions';

import { filter, find, isEqual } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { setDefaultRequest } from '../../containers/customer/actions';
import {
  setAuth,
  setChangePass,
  setChangeUser,
  setToast,
} from '../../containers/client/actions';
import { GoUnverified } from 'react-icons/go';
import { translate } from 'react-i18next';

class Security extends React.Component {
  state = {
    defAcc: null,
    isDisChangeAcc: true,
  };

  componentDidMount() {
    const { token, listAccount } = this.props;
    if (token) this._handleGetAuthList();
    if (listAccount) {
      const _defSubAccount = find(listAccount, (o) => o.isDefSubAcnt === 1);
      if (_defSubAccount) this.setState({ defAcc: _defSubAccount.subAcntNo });
    }
  }

  componentDidUpdate(preProps) {
    const { listAccount, setDefaultSuccess, setDefaultErrors } = this.props;
    if (listAccount && !isEqual(listAccount, preProps.listAccount)) {
      const _defSubAccount = find(listAccount, (o) => o.isDefSubAcnt === 1);
      if (_defSubAccount) this.setState({ defAcc: _defSubAccount.subAcntNo });
    }
    if (setDefaultSuccess && setDefaultSuccess !== preProps.setDefaultSuccess) {
      this._handleToast('Đổi tài khoản mặc định thành công');
      setTimeout(() => {
        window.location.href = '/';
      }, 1000);
    }
    if (
      setDefaultErrors &&
      !!setDefaultErrors.length &&
      setDefaultErrors !== preProps.setDefaultErrors
    ) {
      this._handleToast('Đổi tài khoản mặc định không thành công');
    }
  }

  _handleSetDefault = () => {
    const { token, defaultAccount, auth } = this.props;
    const { defAcc } = this.state;
    console.log(token, defAcc);

    if (token) {
      const uuid = uuidv4();
      const params = {
        group: 'CORE',
        user: token.user,
        session: token.session,
        cmd: 'SetDefault',
        rqId: uuid,
        channel: 'WTS',
        type: auth.type,
        token: auth.token,
        data: {
          acntNo: defaultAccount.acntNo,
          subAcntNo: defAcc,
        },
      };
      this.props.dispatch(setDefaultRequest(params));
    }
  };

  _handleGetAuthList = () => {
    const { token } = this.props;
    console.log(token);
    if (token) {
      const uuid = uuidv4();
      const params = {
        group: 'CORE',
        user: token.user,
        session: token.session,
        cmd: 'GetAuthList',
        rqId: uuid,
        channel: 'WTS',
        data: {
          cif: token.cif,
        },
      };
      this.props.dispatch(authListRequest(params));
    }
  };

  _handleChangeDefAccount = (e) => {
    const { value } = e.target;
    const { listAccount } = this.props;
    console.log(listAccount);
    if (listAccount) {
      const _defSubAccount = find(listAccount, (o) => o.isDefSubAcnt === 1);
      if (_defSubAccount) {
        if (value === _defSubAccount.subAcntNo) {
          this.setState({ defAcc: value, isDisChangeAcc: true });
        } else {
          this.setState({ defAcc: value, isDisChangeAcc: false });
        }
      }
    }
  };

  _handleToast = (msg) => {
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: this.props.t('txt-notice'),
    };
    this.props.dispatch(setToast(toastMsg));
  };

  _handleAuthen = () => {
    this.props.dispatch(setAuth());
  };

  render() {
    const {
      auth,
      token,
      listAccount,
      authen: { actList },
      t,
    } = this.props;

    const { defAcc, isDisChangeAcc } = this.state;

    const _actList =
      actList && actList.list && filter(actList.list, (o) => o.authYn === 'Y');

    return (
      <PerfectScrollBar>
        <div className="d-flex justify-content-md-center">
          <Col
            md="6"
            className="d-flex flex-column"
            style={{ minWidth: '650px' }}
          >
            <div className="d-flex justify-content-between align-items-center mt-3">
              <label className="text-white fz-18">
                {t('txt-label-login-info')}
              </label>
              <span className={'fz-14 ' + (auth.isVerified ? 'i' : 'd')}>
                {auth && auth.isVerified ? (
                  <Fragment>
                    <MdVerifiedUser className="mr-2" />
                    {t('txt-da-xacthuc')}
                  </Fragment>
                ) : (
                  <Fragment>
                    <GoUnverified className="mr-2" />
                    {t('txt-chua-xacthuc')}
                  </Fragment>
                )}
              </span>
            </div>
            <ListGroup className="mt-2">
              <ListGroup.Item className="d-flex align-items-center p-2">
                <span className="fz-14 txt-content w-195">
                  {t('txt-label-login-account')}
                </span>
                <div
                  className="d-flex align-items-center fz-14 text-white font-weight-bold"
                  style={{ width: 'calc( 100% - 195px )' }}
                >
                  <span className="mr-auto">{token && token.user}</span>
                  {auth && auth.isVerified ? (
                    <Button
                      variant="info"
                      className="fz-14 font-weight-bold text-white w_165"
                      onClick={() => this.props.dispatch(setChangeUser())}
                    >
                      {t('txt-change')}
                    </Button>
                  ) : (
                    <Button
                      variant="warning"
                      className="fz-14 font-weight-bold text-white w-140"
                      onClick={() => this._handleAuthen()}
                    >
                      {t('txt-xacthuc')}
                    </Button>
                  )}
                </div>
              </ListGroup.Item>
            </ListGroup>
            <label className="text-white fz-18 mt-3">{`${t('txt-pass')} & ${t(
              'txt-label-security'
            )}`}</label>
            <ListGroup className="mt-2">
              <ListGroup.Item className="d-flex align-items-center p-2">
                <span className="fz-14 txt-content w-195">
                  {t('txt-label-current-password')}
                </span>
                <div
                  className="d-flex align-items-center fz-14 text-white font-weight-bold"
                  style={{ width: 'calc( 100% - 195px )' }}
                >
                  <span className="mr-auto">{'******'}</span>
                  {auth && auth.isVerified ? (
                    <Button
                      variant="info"
                      className="fz-14 font-weight-bold text-white w_165"
                      onClick={() => this.props.dispatch(setChangePass())}
                    >
                      {t('txt-change-pass')}
                    </Button>
                  ) : (
                    <Button
                      variant="warning"
                      className="fz-14 font-weight-bold text-white w-140"
                      onClick={() => this._handleAuthen()}
                    >
                      {t('txt-xacthuc')}
                    </Button>
                  )}
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex align-items-center p-2">
                <span className="fz-14 txt-content w-195">
                  {t('txt-label-default-account')}
                </span>
                <div
                  className="d-flex align-items-center fz-14 text-white font-weight-bold"
                  style={{ width: 'calc( 100% - 195px )' }}
                >
                  {defAcc && (
                    <select
                      className="form-control form-input fz-14 w-195 mr-auto"
                      value={defAcc}
                      onChange={this._handleChangeDefAccount}
                    >
                      {listAccount &&
                        listAccount.map((item, index) => (
                          <option value={item.subAcntNo} key={'acc_' + index}>
                            {item.label}
                          </option>
                        ))}
                    </select>
                  )}
                  {auth && auth.isVerified ? (
                    <Button
                      variant="info"
                      disabled={isDisChangeAcc}
                      className="fz-14 font-weight-bold text-white w_165"
                      onClick={this._handleSetDefault}
                    >
                      {t('txt-change-account')}
                    </Button>
                  ) : (
                    <Button
                      variant="warning"
                      className="fz-14 font-weight-bold text-white w-140"
                      onClick={() => this._handleAuthen()}
                    >
                      {t('txt-xacthuc')}
                    </Button>
                  )}
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex align-items-top p-2">
                <span className="fz-14 txt-content w-195">
                  {t('txt-label-authentication-registered')}
                </span>
                <div
                  className="d-flex flex-column justify-content-left fz-14 text-white font-weight-bold"
                  style={{ width: 'calc( 100% - 195px )' }}
                >
                  <span>{`1. Smart OTP`}</span>
                  {_actList &&
                    _actList.map((item, i) => (
                      <span key={'auth_' + i}>{`${i + 2}. ${
                        item.authType === 'TOP'
                          ? 'SMS OTP'
                          : item.authType === 'CA'
                          ? 'Digital signature'
                          : item.authType
                      }`}</span>
                    ))}
                </div>
              </ListGroup.Item>
            </ListGroup>
            <p className="txt-content fz-14 mt-3 mb-3 text-center">
              {t('txt-make-sure-can-access')}
            </p>
            <a
              href={`tel:02462823535`}
              className="text-center text-white fz-12 mb-3 mx-auto"
              style={{
                width: '120px',
                backgroundColor: '#1BA0E1',
                borderRadius: '18px',
                padding: '5px',
              }}
            >
              <MdPhone className="mr-2" />
              {'0246.282.3535'}
            </a>
          </Col>
        </div>
      </PerfectScrollBar>
    );
  }
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getAuth = makeGetAuth();
  const getListAccount = makeGetListAccount();
  const getDefaultAccount = makeGetDefaultAccount();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      auth: getAuth(state),
      listAccount: getListAccount(state),
      defaultAccount: getDefaultAccount(state),
      authen: state.authen,
      setDefaultSuccess: state.customer.setDefaultSuccess,
      setDefaultErrors: state.customer.setDefaultErrors,
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(Security)
);
